export default __webpack_public_path__ + "static/media/SWT1230.34I-40343_-23909_0.795d6de6.jpg";